import { ReactElement, ReactNode, useMemo } from 'react';
import { Api } from '@/api';
import { OpenApiContext } from './context';

type Props = {
    readonly children?: ReactNode;
};

export function OpenApiProvider({ children }: Props): ReactElement {
    const openApi = useMemo(() => {
        return new Api();
    }, []);
    return (
        <OpenApiContext.Provider value={{ openApi }}>
            {children}
        </OpenApiContext.Provider>
    );
}
